module.exports = __webpack_public_path__ + "img/a5-عمودی.e2dcd29e.png";